import { observer } from 'mobx-react-lite';
import React from 'react';
import Alert from '../../widgets/Alert';
import { appStore } from '../../store/mobx/app.store';

export const AlertProvider = observer(({ children }) => {
  const { alert, removeAlert } = appStore;

  return (
    <>
      {children}
      {alert && (
        <Alert
          open={!!alert}
          status={alert.status}
          message={alert.message}
          onClose={removeAlert}
          onSubmit={alert.onConfirm}
        />
      )}
    </>
  );
});

export default AlertProvider;
